import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle2, XCircle } from "lucide-react";

type LineConnectionResultModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  success: boolean;
  errorType?: string;
};

export const LineConnectionResultModal = ({
  open,
  onOpenChange,
  success,
  errorType
}: LineConnectionResultModalProps) => {
  const getErrorMessage = () => {
    switch (errorType) {
      case "invalid_state":
        return "セッションが無効です。もう一度お試しください。";
      case "oauth_failed":
        return "認証処理でエラーが発生しました。";
      default:
        return "予期しないエラーが発生しました。";
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-80 rounded-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-center gap-2">
            {success ? (
              <CheckCircle2 className="h-6 w-6 text-green-500" />
            ) : (
              <XCircle className="h-6 w-6 text-red-500" />
            )}
            <span>{success ? "LINE連携完了" : "LINE連携失敗"}</span>
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-center text-sm text-gray-600">
            {success ? "LINEアカウントとの連携が完了しました。" : getErrorMessage()}
          </p>
          <Button className="w-full" onClick={() => onOpenChange(false)}>
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
